module.exports = __webpack_public_path__ + "static/media/clubs_2.bc0102a2.png";